import { render, staticRenderFns } from "./InputsRisk.vue?vue&type=template&id=77d08844&scoped=true&"
import script from "./InputsRisk.vue?vue&type=script&lang=js&"
export * from "./InputsRisk.vue?vue&type=script&lang=js&"
import style0 from "./InputsRisk.vue?vue&type=style&index=0&id=77d08844&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d08844",
  null
  
)

export default component.exports